/* Copyright (c) 2017 Backpack Health LLC */
/* global IS_ANDROID_BUILD */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import ContentFrame from '../../applicationFrame/ContentFrame';
import { ScrollAwareAppNavStep, ScrollAwareContext, ScrollAwareScroller } from '../../components/ScrollAware';
import { AppHeaderScrollableTextWithLanguage } from '../../components/appNav/AppHeaderScrollable';
import Card, { CardSection } from '../../components/card/Card';
import Spacer from '../../components/Spacer';
import ContentLoader from '../../components/ContentLoader';

import AppUtils from '../../../utilities/AppUtils';
import UserService from '../../../apiServices/UserService';
import ContentWrapper from '../../components/ContentWrapper';

interface Props {
  token: string;
}

interface State {
  isDataLoaded: boolean;
}

class EmailVerificationSuccess extends React.Component<Props, State> {

  state: State = {
    isDataLoaded: false,
  };

  UNSAFE_componentWillMount() {
    const { token } = this.props;
    UserService.confirmEmailVerification(token).then(res => {
      this.setState({ isDataLoaded: true });
    });
  }

  handleOnDone = () => {
    AppUtils.reloadApp();
  }

  render() {
    return (
      <ScrollAwareContext>
        <ScrollAwareAppNavStep
          submit={null}
          done={this.handleOnDone}
          color="white"
        />
        <ContentLoader isContentLoaded={this.state.isDataLoaded} blockRenderUntilLoaded>
          <ContentFrame>
            <ScrollAwareScroller>
              <AppHeaderScrollableTextWithLanguage
                id="verifyEmailSuccess.title.text"
                allowLanguageToggle={false}
              />
              <ContentWrapper>
                <Card>
                  <CardSection hasBorder={false}>
                    <div className="font-color-gsDark font-headline">
                      <FormattedMessage id="verifyEmailSuccess.heading.text" />
                    </div>

                    <Spacer size="9" />

                    <div className="font-subhead">
                      <FormattedMessage id="verifyEmailSuccess.message.text" />
                    </div>
                  </CardSection>
                </Card>
              </ContentWrapper>
            </ScrollAwareScroller>
          </ContentFrame>
        </ContentLoader>
      </ScrollAwareContext>
    );
  }
}

export default EmailVerificationSuccess;
